import { Partner } from './types';

export const partners: Partner[] = [
  {
    name: 'Makerere University Business School',
    description:
      'Leading East African institution providing academic excellence and research expertise in climate finance.',
    imageSrc: '/images/MUBS-logo.jpeg',
    website: 'https://www.mubs.ac.ug/',
  },
  {
    name: 'Africa Research and Impact Network',
    description:
      'Connecting researchers and practitioners across Africa to drive sustainable development solutions.',
    imageSrc: '/images/Arin-logo.jpg',
    website: 'https://www.arin-africa.org/',
  },
  {
    name: 'Frankfurt School of Finance & Management',
    description:
      'World-renowned institution bringing international expertise in sustainable finance and climate action.',
    imageSrc: '/images/Frankfurt-School-logo.jpg',
    website: 'https://www.fs-unep-centre.org/',
  },
];
